import React from "react";

const MapIframe = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <iframe
        title="Google Maps Location" 
        width="100%"
        height="450"
        style={{ border: "0" }} 
        loading="lazy"
        allowFullScreen
        src={`https://www.google.com/maps/embed/v1/place?q=place_id:ChIJh6VzNgJxrjsRX1BJq3l80b4&key=AIzaSyAs3qmqh9keWdDU8f9XigeJ2RyAjqA8yio`}
      ></iframe>
    </div>
  );
};

export default MapIframe;
